var React = require('react');

function MapPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 0.5C4.1625 0.5 0.25 4.4125 0.25 9.25C0.25 15.8125 9 25.5 9 25.5C9 25.5 17.75 15.8125 17.75 9.25C17.75 4.4125 13.8375 0.5 9 0.5ZM9 12.375C7.275 12.375 5.875 10.975 5.875 9.25C5.875 7.525 7.275 6.125 9 6.125C10.725 6.125 12.125 7.525 12.125 9.25C12.125 10.975 10.725 12.375 9 12.375Z","fill":"#B8AD9E"}));
}

MapPin.defaultProps = {"width":"18","height":"26","viewBox":"0 0 18 26","fill":"none"};

module.exports = MapPin;

MapPin.default = MapPin;
